<template>
  <div class="wrapper">
    <div class="main-panel w-100" style="float: none;">
      <top-navbar></top-navbar>
      <dashboard-content> </dashboard-content>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue'
import DashboardContent from './Content.vue'

export default {
  name: 'DashboardLayout',
  components: {
    TopNavbar,
    DashboardContent
  },
  methods: {
    openLink() {
      window.open('https://www.ticz.io/', '_blank')
    }
  }
}
</script>
